import { DisplayTotalPriceResponseBuilder } from './DisplayTotalPriceResponseBuilder';
import { LoyaltyOfferResponseBuilder } from './LoyaltyOfferResponseBuilder';
import { DisplayPromocodeItemResponseBuilder } from './DisplayPromocodeItemResponseBuilder';
import { PromotionInfoResponseBuilder } from './PromotionInfoResponseBuilder';
import { BadgesResponseBuilder } from './BadgesResponseBuilder';
import { IBaseArgument } from './IBaseArgument';
import { BaseResponseBuilder } from './BaseResponseBuilder';

export class SummaryElementResponseBuilder extends BaseResponseBuilder {
    constructor() {
        super('SummaryElement');
    }
    public withDisplayType = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['displayType'] = this.initField(null, args);
        return this;
    }

    public withQuantity = (shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['quantity'] = this.initField(null, args);
        return this;
    }

    public withTotal = (builder: DisplayTotalPriceResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['total'] = this.initField(builder, args);
        return this;
    }

    public withLoyaltyOffers = (builder: LoyaltyOfferResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['loyaltyOffers'] = this.initField(builder, args);
        return this;
    }

    public withPromocodeItems = (builder: DisplayPromocodeItemResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['promocodeItems'] = this.initField(builder, args);
        return this;
    }

    public withPromotionInfo = (builder: PromotionInfoResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['promotionInfo'] = this.initField(builder, args);
        return this;
    }

    public withBadges = (builder: BadgesResponseBuilder, shouldAsk: boolean = true) => {
        const args: IBaseArgument[] = [];

        if (shouldAsk) this.fields['badges'] = this.initField(builder, args);
        return this;
    }
}
